<template>
  <BaseEditModal
    :displayName="newItem ? 'Create Button' : 'Edit Button'"
    helpFileName="CreatePanelModal"
    :tabs="tabs"
    :icon="'mdi-card-plus-outline'"
    :masterObj="buttonToEdit"
    :saveFunc="saveItem"
    :deleteFunc="deleteItem"
    :instanceDeletable="props.button"
    @close="emit('close')"
    @locked="(bool) => emit('locked', bool)"></BaseEditModal>
</template>
<script setup>
import CreateNewButton from './CreateNewButton.vue';
import CreateNewButtonTriggers from './CreateNewButtonTriggers.vue';

import BaseEditModal from '../Shared/Modals/BaseEditModal.vue';
import { $http } from '../../stores/http.js';

const props = defineProps(['index', 'panelUid', 'button']);
const emit = defineEmits(['close', 'locked']);
const newItem = !!!props.button;

var buttonToEdit = {
  name: '',
  icon: '',
  color: '#5d6add',
  index: props.index,
  triggers: [],
};
if (props.button) {
  buttonToEdit = JSON.parse(JSON.stringify(props.button));
}

const tabs = [
  {
    id: 0,
    title: 'Details',
    icon: 'mdi-square-edit-outline',
    display: true,
    component: CreateNewButton,
    props: {
      index: props.index,
      panelUid: props.panelUid,
    },
  },
  {
    id: 1,
    title: 'Triggers',
    icon: 'mdi-share-all',
    display: true,
    component: CreateNewButtonTriggers,
    props: {
      index: props.index,
      panelUid: props.panelUid,
    },
  },
];
async function saveItem(uid, data) {
  data.index = props.index;
  try {
    await $http(
      'PUT',
      `/update_panel_button?panel_uid=${props.panelUid}`,
      JSON.stringify(data)
    );
    if (newItem) {
      emit('close');
    }
  } catch (error) {
    console.log(error);
  }
}
async function deleteItem() {
  try {
    await $http(
      'DELETE',
      `/delete_panel_button?panel_uid=${props.panelUid}&index=${props.index}`
    );
  } catch (error) {
    console.log(error);
  }

  emit('close');
}
</script>
